<div *ngIf="account?.accountId">
   
    <div class="ms-1">
        <div class="d-inline me-4 fw-bold truncate" [pTooltip]="account.company ? account.company : ''" appShowToolTipIfTruncated>Organization Name: {{
            account.company }}</div>
        <div class="d-inline me-4 fw-bold">Account ID: {{ account.accountId }}</div>
        <div class="d-inline me-4 fw-bold">Number of Leased Codes: {{ leasedCodeCount }} </div>
    </div>

    <div class="row ms-1 mt-4" *ngIf="managingAccountCompanyName">
        <div class="col-9 p-0">

      <span class="fw-bold">Managing Account:</span>
      <span class="ms-2">{{managingAccountCompanyName}}</span>
      <span class="ms-2">(Account ID: {{account.managingAccountId}})</span>
      </div>
    </div>

    <div class="row ms-1 mt-4" *appNotAuthIf="[CognitoGroup.Carrier, CognitoGroup.CarrierRegistrant]">
        <div class="col-4 p-0">
            <div data-testid='programType' class="mb-1">
              <span class="fw-bold">Program Type:</span> {{ displayedProgramType }} 
              <span *ngIf="programStatusText">{{ programStatusText }}</span>
            </div>
            <div *ngIf="account.unappliedCredits !== 0 && account.unappliedCredits !== undefined">
              <span data-testid='accountCredit' class="fw-bold">Account Credit:</span>&nbsp;<span>{{ account.unappliedCredits | currency }}</span>
            </div>
        </div>
        <div class="col-6 p-0">
            <div *ngIf="account.monBillEnabled && account.monBillAutoPayEnabled !== undefined" class="me-4 mb-2"><span
                    class="fw-bold">Monthly Billing Payment Plan:</span> {{ account.monBillAutoPayEnabled ?
                'Auto-pay' : 'Manual Pay' }}</div>
            <div *ngIf="account.monBillEnabled" class="me-4 mb-2"><span class="fw-bold">Last Monthly Billing
                    Payment Status:</span> {{ monthlyBillingStatus }}</div>
            <div *ngIf="account.monBillEnabled" class="me-4 mb-2"><span class="fw-bold">Default Monthly Billing
                    PO #:</span> {{ account.monBillPoNumber }}</div>
        </div>
    </div>

    <div class="row ">
        <div class="col-4 mt-4">
            <h5>Account Contact</h5>
            <div class="me-4 mb-1">Name: {{ account.firstName }} {{ account.lastName }}</div>
            <div class="me-4 mb-1">Phone: {{ account.phone | phoneNumber }}</div>
            <div class="me-4 mb-1">Extension: {{ account.phoneExtension }}</div>
            <div class="me-4 mb-1 truncate" [pTooltip]="account.email ? account.email : ''" tooltipPosition="top" appShowToolTipIfTruncated>Email: {{ account.email }}</div>

        </div>
        <div class="col-4 mt-4">
            <h5>Business Details</h5>
            <div class="me-4 mb-1">Legal Entity Type: {{ account.legalEntityType }}</div>
            <div class="me-4 mb-1">Messaging Role: {{ account.messagingRole }}</div>
            <div class="me-4 mb-1">URL: {{ account.companyUrl }}</div>
            <div class="me-4 mb-1">Stock Market Symbol: {{ account.companySymbol }}</div>
            <div class="me-4 mb-1">Federal Tax ID: {{ account.fein }}</div>
            <div class="me-4 mb-1">DUNS: {{ account.duns }}</div>
            <div class="me-4 mb-1">GIIN: {{ account.giin }}</div>
            <div class="me-4 mb-1">LEI: {{ account.lei }}</div>
        </div>
        <div class="col-4 mt-4">
            <h5>Billing Contact</h5>
            <div class="me-4 mb-1">Name: {{account.billingFirstName }} {{ account.billingLastName }}</div>
            <div class="me-4 mb-1">Phone: {{ account.billingPhone | phoneNumber }}</div>
            <div class="me-4 mb-1">Extension: {{ account.billingPhoneExtension }}</div>
            <div class="me-4 mb-1 truncate" [pTooltip]="account.billingEmail ? account.billingEmail : ''" tooltipPosition="top" appShowToolTipIfTruncated>Email: {{ account.billingEmail }}</div>

        </div>
        <div class="col-4 mt-4">
            <h5>Secondary Account Contact</h5>
            <div class="me-4 mb-1">Name: {{ account.secondaryFirstName }} {{ account.secondaryLastName }}</div>
            <div class="me-4 mb-1">Phone: {{ account.secondaryPhone | phoneNumber }}</div>
            <div class="me-4 mb-1">Extension: {{ account.secondaryPhoneExtension }}</div>
            <div class="me-4 mb-1 truncate" [pTooltip]="account.secondaryEmail ? account.secondaryEmail : ''" tooltipPosition="top" appShowToolTipIfTruncated>Email: {{ account.secondaryEmail }}</div>
        </div>
        <div class="col-4 mt-4">
            <h5>Business Address</h5>
            <div class="me-4 mb-1 truncate" [pTooltip]="account.address1 ? account.address1 : ''" tooltipPosition="top" appShowToolTipIfTruncated>{{ account.address1 }} </div>
            <div class="me-4 mb-1 truncate" [pTooltip]="account.address2 ? account.address2 : ''" tooltipPosition="top" appShowToolTipIfTruncated *ngIf="account.address2" >{{ account.address2 ? account.address2 : ''}}</div>
            <div class="me-4 mb-1 truncate-wrap" [pTooltip]="addressCombined ? addressCombined : ''" tooltipPosition="top" appShowToolTipIfTruncated> {{ addressCombined }} </div>
            <div class="me-4 mb-1"> {{ account.country | scrConfig:'country' }} </div>
        </div>
        <div class="col-4 mt-4" >
            <h5>Billing Address</h5>
            <div class="me-4 mb-1 truncate" [pTooltip]="account.billingAddress1 ? account.billingAddress1 : ''" tooltipPosition="top" appShowToolTipIfTruncated>{{ account.billingAddress1 }} </div>
            <div class="me-4 mb-1 truncate" [pTooltip]="account.billingAddress2 ? account.billingAddress2 : ''" tooltipPosition="top" appShowToolTipIfTruncated *ngIf="account.billingAddress2">{{ account.billingAddress2 ? account.billingAddress2
                : ''}} </div>
            <div class="me-4 mb-1 truncate-wrap" [pTooltip]="billingAddressCombined ? billingAddressCombined : ''" tooltipPosition="top" appShowToolTipIfTruncated> {{ billingAddressCombined }} </div>
            <div class="me-4 mb-1"> {{ account.billingCountry | scrConfig:'country' }}</div>
        </div>
    </div>
</div>